import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const redirectToCanonicalHost = () => {
  if (window.location.hostname !== "www.gigathlon.in") return false;

  window.location.replace(
    `https://gigathlon.in${window.location.pathname}${window.location.search}${window.location.hash}`
  );
  return true;
};

if (!redirectToCanonicalHost()) {
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();

  if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js")
        .then((registration) => registration.update())
        .catch((error) => {
          console.warn("Passport offline support could not be registered:", error);
        });
    });
  }
}
